import {observer} from 'mobx-react-lite'
import "./../common/page.css"

const PageLayout = ({ header, filters, children, pagination }) => {
  return (
    <div className="page">
      {header && <div className="page-header">{header}</div>}
      {filters && <div className="page-filters">{filters}</div>}
      <div className="page-content">{children}</div>
      {pagination && <div className="page-pagination">{pagination}</div>}
    </div>
  );
};

export default observer(PageLayout)
